<template>
  <el-dialog :visible.sync="showTakeDialog" custom-class="take-dialog" title="耗材领取" width="562px" :close-on-click-modal="false">
    <el-dialog
      :visible.sync="showBuyProcess"
      append-to-body
      title="OrthoNow! 购销协议"
      custom-class="take-dialog"
      width="700px">
      <div style="max-height: 60vh;overflow-y: auto" v-html="agreementCont"></div>
    </el-dialog>
    <AddDesignCard ref="addDesignCard"
                   :key="drawerKey"
                   :drawer="drawer"
                   :designType="designType"
                   :patient_id.sync="form.patient_id"
                   @designCardData="getDesignCardData"/>
    <div v-loading="formLoading">
      <div class="receive-warp" >
        <div class="take-radio " v-if="product.type == 1 && !product.is_yxjzq_product">
          <div class="take-dialog-title" style="margin-bottom: 10px">定制类型<span class="require">*</span></div>
          <div :class="form.type == 2? 'on':''" class="take-radio-item" @click="typeChange(2)">
            <div :class="form.type == 2? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
            <div>
              <div class="take-radio-info1">数字模型定制</div>
              <div class="take-radio-info2">上传stl格式文档（数字模型数据）</div>
            </div>
          </div>
          <div :class="form.type == 1? 'on':''" class="take-radio-item" @click="typeChange(1)">
            <div :class="form.type == 1? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
            <div>
              <div class="take-radio-info1">石膏模型定制</div>
              <div class="take-radio-info2">
                选择石膏模型警告誊写设计单编号到纸质文档，并和石膏一起寄送。邮寄地址请联系业务员或客服获取。
              </div>
            </div>
          </div>
        </div>
        <div class="take-num-line" v-if="product.type == 1 && form.type == 2">
          <div class="take-dialog-title">文件上传<span class="require">*</span></div>
          <div v-for="(item,index) in model_file" class="d-flex-between" style="align-items: center">
            <div class="grey-12" style="margin-top: 16px">{{ item.attachment }}</div>
            <div class="iconfont icon-pizhu-qingkonghuaban del-img-btn" @click="delModelFile(index)"></div>
          </div>
          <div class="upload-img-item uploadItem3-s margin-top-16">
            <img alt="" class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png">
            <img alt="" class="upload-img-item-icon" src="@/assets/img/case_management/upload-file-icon.png">
            <div class="upload-img-item-name">上传文件</div>
            <input :multiple="true" type="file" @change="handleFileChange">
            <div class="input-cover"></div>
          </div>
        </div>
        <div class="take-radio" v-if="!isFromChat">
          <div class="take-dialog-title" style="margin-bottom: 10px">匹配病例<span class="require">*</span></div>
          <template v-if="!product.is_yxjzq_product">
            <div :class="!form.is_match_patient? 'on':''" class="take-radio-item" @click="matchPatientChange(false)">
              <div :class="!form.is_match_patient? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
              <div>
                <div class="take-radio-info1">不匹配病例</div>
                <div class="take-radio-info2">
                  耗材不匹配病例，导师可能无法查看及适时与您沟通，您也将收到一定损失，请谨慎选择
                </div>
              </div>
            </div>
            <div :class="form.is_match_patient? 'on':''" class="take-radio-item" @click="matchPatientChange(true)">
              <div :class="form.is_match_patient? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
              <div>
                <div class="take-radio-info1">匹配病例</div>
                <div class="take-radio-info2">选择病例 → 选择资料卡即可匹配完成。可在资料卡详情中查看耗材进度</div>
              </div>
            </div>
          </template>
        </div>
        <div class="upload-case" v-if="form.is_match_patient">
          <div class="upload-case-item " v-if="!isFromChat">
            <Patient v-if="form.is_match_patient" :patient_id.sync="form.patient_id" @patient="handleSelectPatient">
              <!-- 添加病例的样式-->
              <div class="iconfont icon-xinjian" v-if="!form.patient_id"></div>
              <!-- 选中病例 -->
              <div v-else>
                <img class="case-person-del" src="@/assets/img/case_management/del.png" @click.stop="handlePatientDel">
                <div class="d-flex-between" style="align-items: center">
                  <div class="case-person-name">{{ patient.name }}
                    <div
                      v-if="patient.show_red_dot"
                      class="new-dot"></div>
                  </div>
                  <div class="case-person-info">{{ patient.age_text }}</div>
                </div>
                <div class="case-person-info">{{patient.no}}</div>
                <div class="case-person-time-line">
                  <div class="case-person-time"><img alt="" src="@/assets/img/doctor-detail/time-shouzhen.png">{{patient.sz_date}}
                  </div>
                  <div class="case-person-time-split"></div>
                  <div class="case-person-time"><img alt="" src="@/assets/img/doctor-detail/time-shouzhen.png">{{patient.new_date}}
                  </div>
                </div>
                <div class="case-person-cycle package-tag" :class="patient.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'">{{patient.confirm_first_case_type_text != '' ? patient.confirm_first_case_type_text :patient.first_case_type_name}}</div>
              </div>
            </Patient>
          </div>
          <div v-if="isFromChat && patient.id" :key="patient.id" class="upload-case-item design-list-on" >
            <div class="d-flex-between" style="align-items: center">
              <div class="case-person-name">{{ patient.name }}
                <div
                  v-if="patient.show_red_dot"
                  class="new-dot"></div>
              </div>
              <div class="case-person-info">{{ patient.age_text }}</div>
            </div>
            <div class="case-person-info">{{patient.no}}</div>
            <div class="case-person-time-line">
              <div class="case-person-time"><img alt="" src="@/assets/img/doctor-detail/time-shouzhen.png">{{patient.sz_date}}
              </div>
              <div class="case-person-time-split"></div>
              <div class="case-person-time"><img alt="" src="@/assets/img/doctor-detail/time-shouzhen.png">{{patient.new_date}}
              </div>
            </div>
            <div class="case-person-cycle package-tag" :class="patient.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'">{{patient.confirm_first_case_type_text != '' ? patient.confirm_first_case_type_text :patient.first_case_type_name}}</div>
          </div>
        </div>

        <div class="d-flex-between take-num-line">
          <div class="take-dialog-title">数量<span class="require">*</span></div>
          <div class="take-num">
            <div :class="form.product_quantity > 1 ? 'on' : ''" @click="numChange('del')">-</div>
            <input v-model="form.product_quantity" @input="numInput">
            <div class="on" @click="numChange('add')">+</div>
          </div>
        </div>

        <div class="take-num-line" v-if="product.type == 1 && !product.is_yxjzq_product">
          <div class="take-dialog-title">关联设计单<span class="require">*</span></div>
          <DesignCard :patient_id="form.patient_id"
                      :openDrawer="openDrawer"
                      :isFit="form.is_match_patient"
                      :type="5"
                      @designModel="getDesignModel"
                      @designCardData="getDesignCardData">
            <div class="take-design-btn d-flex-between">
              <div class="black-14">设计单</div>
              <span style="text-align: left;flex: 1;padding-left: 15px">{{ designCardDetail.id ? designCardDetail.type_name + ' ' +  designCardDetail.card_date : "请选择设计单" }}</span>
              <i class="iconfont icon-youjiantou"></i>
            </div>
          </DesignCard>
        </div>
        <div class="take-num-line" v-if="product.type == 1 && product.is_yxjzq_product">
          <div>关联复诊卡<span class="require">*</span></div>
          <DesignCard :patient_id="form.patient_id"
                      :openDrawer="openDrawer"
                      :isFit="true"
                      :type="2"
                      @designCardData="getDesignCardData">
            <div class="take-design-btn d-flex-between">
              <div class="black-14">复诊卡</div>
              <span style="text-align: left;flex: 1;padding-left: 15px">{{ designCardDetail.id ? designCardDetail.type_name + ' ' +  designCardDetail.card_date : "请选择复诊卡" }}</span>
              <i class="iconfont icon-youjiantou"></i>
            </div>
          </DesignCard>
        </div>
        <div class="take-num-line">
          <div class="take-dialog-title">收货信息<span class="require">*</span></div>
          <div class="d-flex-between">
            <div class="add-data-item">
              <div>姓名</div>
              <div class="add-data-item-input"><input v-model="form.receiver_name" type="text"></div>
            </div>
            <div class="add-data-item">
              <div>电话</div>
              <div class="add-data-item-input"><input v-model="form.receiver_phone" type="text"></div>
            </div>
            <div v-if="areaData.length" class="add-data-item">
              <div>地区</div>
              <el-cascader v-model="receiverArea" :options="areaData" @change="handleAreaChange"></el-cascader>
              <!--              <div  class="add-data-item-input"><input type="text" v-model="receiveOption.receiver_province"></div>-->
            </div>
          </div>
          <div class="add-data-item">
            <div>详细地址</div>
            <div class="add-data-item-input" style="width: 100%"><input v-model="form.receiver_address" style="width: 100%" type="text">
            </div>
          </div>
        </div>
        <div class="take-dialog-bottom" style="justify-content: space-between">
          <div class="login-read" style="width: 196px" @click="isAgree = !isAgree" v-if="!form.is_match_patient || patient.case_type == 1">
            <div :class="isAgree ? 'login-read-ok' : ''" class="iconfont icon-dangou login-read-radio"></div>
            <div class="login-read-info">我已阅读并同意<span @click.stop="showBuyProcess = true">购销协议</span></div>
          </div>
          <!--        占位div-->
          <div></div>
          <div class="d-flex" style="width: fit-content">
            <div class="take-dialog-close" @click="showTakeDialog = false">取消</div>
            <div class="take-dialog-open" @click="submit">确定</div>
          </div>
        </div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import DesignCard from "@/views/consumables/components/DesignCard";
import Patient from "@/views/consumables/components/Patient";
import AddDesignCard from "@/views/consumables/components/AddDesignCard";
import {GetArea} from "@/http/api";
import {create} from "@/http/order";
import {info} from "@/http/product";
import ossUpload from "@/http/ossUpload";
import {getListByTypeCode} from "@/http/user_center";

export default {
  name: "ReceiveDialog",
  components: { DesignCard, Patient ,AddDesignCard},
  data(){
    return{
      drawer:false,
      drawerKey:1,
      showTakeDialog: false,
      showDesignDialog: false,
      loading: false,
      receiverArea: [],
      areaData: [],
      form: {
        product_id: undefined,
        product_quantity: 1,
        is_match_patient: true, //不匹配/匹配
        patient_id: undefined,
        design_card_id: undefined,
        comment: undefined,
        type: 2,//1石膏模型定制，2数字模型定制
        model_file_url: undefined,
        fuzhen_card_id: undefined,
        receiver_name: undefined,
        receiver_phone: undefined,
        receiver_province: undefined,
        receiver_city: undefined,
        receiver_district: undefined,
        receiver_address: undefined,
      },
      formLoading: false,
      patient: {},
      isFromChat: false,
      designType:{},
      designCardDetail:{},
      model_file_url:[],
      model_file:[],
      isAgree:false,
      showBuyProcess:false,
      agreementCont:''
    }
  },
  props:{
    productId:null,
    product:{},
  },
  mounted() {
    GetArea({ level: 2 }).then((res) => {
      this.areaData = res.data;
    });
    this.getAgreement()
  },
  methods:{
    getAgreement(){
      getListByTypeCode({ type_code: ["gouxiaoxieyi"] }).then(
        (res) => {
          if (res.code == 200) {
            this.agreementCont = res.data.gouxiaoxieyi;
          }
        }
      );
    },
    openDrawer(){
      this.drawer = true
      this.drawerKey = new Date().getTime()
    },
    getDesignModel(data){
      this.designType = data
    },
    getDesignCardData(data){
      this.designCardDetail = data
    },
    fromChange(data){
      //从聊天框过来自动选择病例
      this.isFromChat = true
      this.form.is_match_patient = true
      this.handleSelectPatient(data)
    },
    getData() {
      this.loading = true;
      info({ id: this.productId }).then((res) => {
        this.product = res.data;
        this.loading = false;
      });
    },
    typeChange(val) {
      this.form.type = val;
    },
    matchPatientChange(val) {
      this.form.is_match_patient = val;
      this.handlePatientDel();
      //如果不匹配病例 删除病例信息
      // if (!this.form.is_match_patient) {
      //   this.handlePatientDel();
      // }
    },
    numChange(type) {
      if (type == "del" && this.form.product_quantity > 1)
        this.form.product_quantity = Number(this.form.product_quantity) - 1;
      if (type == "add")
        this.form.product_quantity = Number(this.form.product_quantity) + 1;
    },
    numInput() {
      if (isNaN(this.form.product_quantity)) {
        this.form.product_quantity = 1;
      }
    },
    handleFileChange(e){
      var _that = this
      for (let i = 0; i < e.target.files.length; i++) {
        ossUpload.bucketUpload(e.target.files[i], (res) => {
          this.model_file_url.push(res.url)
          this.model_file.push(res)
        }, (err) => {
          this.$message({
            type: "error",
            message: '上传失败'
          })
        }, 'duole-images', '/upload/file/pc/')
      }
    },
    delModelFile(i){
      this.model_file_url.splice(i,1)
      this.model_file.splice(i,1)
    },
    handleAreaChange(val) {
      this.receiverArea = val;
      this.form.receiver_province = val[0];
      this.form.receiver_city = val[1];
    },
    handleOpen(type,data) {
      this.initForm(type,data);
      this.showTakeDialog = true;
    },
    submit() {
      this.form.product_id = this.productId
      if (this.formCheck()) {
        let opt = {
          checked_protocol:1,
          product_id:this.productId,
          product_quantity:this.form.product_quantity,
          receiver_name:this.form.receiver_name,
          receiver_phone:this.form.receiver_phone,
          receiver_province:this.form.receiver_province,
          receiver_city:this.form.receiver_city,
          receiver_district:this.form.receiver_district,
          receiver_address:this.form.receiver_address
        }
        if (this.product.is_yxjzq_product){
          opt.patient_id = this.form.patient_id
          opt.fuzhen_card_id = this.designCardDetail.id
        }
        else{
          opt.design_card_id = this.designCardDetail.id
          if (this.form.type == 1) opt.type = this.form.type
          else {
            opt.type = this.form.type
            opt.model_file_url = this.model_file_url
          }
          if(this.form.is_match_patient) opt.patient_id = this.form.patient_id
        }
        this.formLoading = true;
        create(opt).then((res) => {
          this.formLoading = false;
          if (res.code == 200) {
            this.showTakeDialog = false
            if(this.isFromChat){
              this.$emit('chooseResource',res.data)
            }else{
              this.$message({
                type: "success",
                message: "领取成功",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.message[0],
            });
          }
        });
      }
    },
    formCheck() {
      if (!this.form.product_id) {
        return this.showErrorMsg('耗材信息不能为空')
      }
      if (!this.form.product_quantity || this.form.product_quantity <= 0) {
        return this.showErrorMsg('数量不能为空')
      }
      if (
          !this.form.receiver_name ||
          !this.form.receiver_phone ||
          !this.form.receiver_province ||
          !this.form.receiver_city ||
          !this.form.receiver_address
      ) {
        return this.showErrorMsg('请完善收货信息')
      }
      if (this.form.is_match_patient && !this.form.patient_id) {
        return this.showErrorMsg('请选择匹配病例')
      }
      if (this.product.type == 0) {
        //非定制产品
      } else {
        //定制产品
        if(this.form.type == 2 && !this.model_file_url.length){
          return this.showErrorMsg('请上传文件')
        }
        if(!this.designCardDetail.id && !this.product.is_yxjzq_product) return this.showErrorMsg('请选择关联的设计单')
        if(!this.designCardDetail.id && this.product.is_yxjzq_product) return this.showErrorMsg('请选择关联的复诊卡')
      }
      if (!this.form.is_match_patient && !this.isAgree) {
        return this.showErrorMsg('请阅读并同意购销协议')
      }
      if (this.patient.case_type == 1 && !this.isAgree) {
        return this.showErrorMsg('请阅读并同意购销协议')
      }
      return true;
    },
    showErrorMsg(msg) {
      this.$message({
        type: "error",
        message: msg,
      });
      return false;
    },
    handleSelectPatient(item) {
      this.patient = item;
      this.form.patient_id = item.id;
    },
    handlePatientDel() {
      this.patient = {};
      this.form.patient_id = undefined;
    },
    initForm(type,data) {
      // var receiver = {}
      if(type == 'chat'){
        var receiver = {
          receiver_name: data.doctor.real_name,
          receiver_phone: data.doctor.telephone,
          receiver_province: data.doctor.province,
          receiver_city: data.doctor.city,
          // receiver_district: data.doctor.district,
          receiver_address: data.doctor.detail_address,
        }
      }else{
        var member = JSON.parse(localStorage.getItem("member"));
        var receiver = {
          receiver_name: member.real_name,
          receiver_phone: member.telephone,
          receiver_province: member.province,
          receiver_city: member.city,
          // receiver_district: member.district,
          receiver_address: member.detail_address,
        }
      }
      this.form = {
        ...receiver,
        product_id: undefined,
        product_quantity: 1,
        is_match_patient: true, //不匹配/匹配
        patient_id: undefined,
        design_card_id: undefined,
        comment: undefined,
        type: 2,
        model_file_url: undefined,
        fuzhen_card_id: undefined,
      };
      console.log(this.form)
      //默认省市区
      this.receiverArea = [];
      if (receiver.receiver_province) {
        this.receiverArea.push(receiver.receiver_province);
      }
      if (receiver.receiver_city) {
        this.receiverArea.push(receiver.receiver_city);
      }
      // if (receiver.receiver_district) {
      //   this.receiverArea.push(receiver.receiver_district);
      // }
      if (type == 'chat') this.fromChange(data)
      else this.patient = {};

      this.designCardDetail = {}
    }
  }
}
</script>

<style scoped src="../../../../assets/css/consumables.css"></style>>
<style>
.add-data-item-input input,
.add-data-item .el-cascader input {
  width: 168px;
  height: 34px;
  background: #f4f4f4;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 14px;
  border: none;
  padding-left: 10px !important;
}
</style>

